import React, { useEffect } from 'react'
import styles from './ColorFilterGroup.module.sass'
import { Tooltip } from '@components/atoms'

interface Props {
  attributo?: any
  filters?: any
  setFilters?: any
  className?: string
}

const ColorFilterGroup = (props: Props) => {
  const {
    attributo = undefined,
    filters = undefined,
    setFilters = undefined,
    className = '',
  } = props

  const isSelected = (item) => {
    return filters.find((val) => val.id === item.id && val.chiave === attributo.chiave)
  }

  return attributo?.valori?.length ? (
    <div className={`${styles.root} ${className}`}>
      {attributo.valori.map((item, i) => (
        <Tooltip key={i} id={item.id.toString()} label={item?.label.split(',')[0]}>
          <button
            className={`${styles.colorContainer} ${
              isSelected(item) ? styles['colorContainer--selected'] : ''
            }`}
            style={{ background: item?.label.split(',')[1] }}
            onClick={() => {
              setFilters(
                isSelected(item)
                  ? filters.filter((f) => !(f.id === item.id && f.chiave === attributo.chiave))
                  : [...filters, { ...item, chiave: attributo.chiave }]
              )
            }}
          />
        </Tooltip>
      ))}
    </div>
  ) : (
    <></>
  )
}

export default ColorFilterGroup
